//#region src/types.ts
var e = /* @__PURE__ */ function(e) {
	return e.Guest = "guest", e.Host = "host", e.Admin = "admin", e.Native = "native", e.Shell = "shell", e;
}({}), t = /* @__PURE__ */ function(e) {
	return e.Local = "local", e.Staging = "staging", e.Production = "production", e;
}({}), n = /* @__PURE__ */ function(e) {
	return e.Fatal = "fatal", e.Error = "error", e.Warning = "warning", e.Info = "info", e;
}({});
//#endregion
export { e as AppContext, t as Environment, n as ErrorLevel };
